var watchlistSelector = {
	label: "Selecteer Volglijst",
	validationErrors: {
		selectWatchlist: "U moet een volglijst selecteren"
	}
};
var nl = {
	watchlistSelector: watchlistSelector
};

export { nl as default, watchlistSelector };
